import React, { useMemo, useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { useLabourStore } from '../../../stores/labour'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectKey, mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import MaskInput, { Masks } from 'react-native-mask-input'
import moment from 'moment'
import Toast from 'react-native-toast-message'

import RadioGroup from 'react-native-radio-buttons-group'

const DCinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params

  const options2 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }
  ]
  const options1 = [
    { key: 1, value: 'Single' },
    {
      key: 2,
      value:
        'Married/domestic partners filing jointly/qualifying widow(er) with dependent child'
    },
    { key: 3, value: 'Head of household' },
    { key: 4, value: 'Married filing separately' },
    {
      key: 5,
      value: 'Married/domestic partners filing separately on same return'
    }
  ]

  const intialValues = {
    filingStatus: null,
    additionalWithholdingAmount: '',
    exemptfromwithholding: '',
    stateOfDomicile: '',
    stateOfDomicileName: '',
    fulltimeStudent: '',
    ageover65: '',
    isblind: '',
    withholdingforyourself: '',
    headofhousehold: '',
    noofdependents: '',
    widowwithdependentchild: '',
    domesticpartner65yearsofage: '',
    partnerisblind: '',
    itemizeddeductions: ''
  }
  const alschema = yup.object({
    filingStatus: yup.string().required('Filing Status is a required field'),
    exemptfromwithholding: yup
      .string()
      .required('Exempt form withholding is a required field'),
    additionalWithholdingAmount: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required(
            'Additional withholding  amount is a required field'
          )
        }
        return schema.nullable()
      }),
    ageover65: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required('Are you over 65 is a required field')
        }
        return schema.nullable()
      }),
    isblind: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required('Are you blind is a required field')
        }
        return schema.nullable()
      }),
    withholdingforyourself: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required(
            'Are you claiming withholding for yourself is a required field'
          )
        }
        return schema.nullable()
      }),
    headofhousehold: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required(
            'Are you filing as a head of household is a required field'
          )
        }
        return schema.nullable()
      }),
    noofdependents: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required('No of dependents is a required field')
        }
        return schema.nullable()
      }),
    widowwithdependentchild: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required(
            'Are you a qualifying widow is a required field'
          )
        }
        return schema.nullable()
      }),
    domesticpartner65yearsofage: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required(
            'Is your registered domestic partner is 65 or over is a required field'
          )
        }
        return schema.nullable()
      }),
    partnerisblind: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required(
            'Is your registered domestic partner is blind is a required field'
          )
        }
        return schema.nullable()
      }),
    itemizeddeductions: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 1) {
          return schema.required(
            ' Estimate of your itemized deductions  is a required field'
          )
        }
        return schema.nullable()
      }),
    stateOfDomicile: yup
      .string()
      .required('Is your state of domicile is a state is a required field '),
    stateOfDomicileName: yup
      .string()
      .when('stateOfDomicile', (stateOfDomicile: any, schema) => {
        if (stateOfDomicile == 1) {
          return schema.required('State of domicile is a required field')
        }
        return schema.nullable()
      }),

    fulltimeStudent: yup
      .string()
      .when('exemptfromwithholding', (exemptfromwithholding: any, schema) => {
        if (exemptfromwithholding == 2) {
          return schema.required(
            'Are you a full time student is a required field'
          )
        }
        return schema.nullable()
      })
  })

  const { loading, postdconline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()

  let filingdescription = ''

  const handleresetvalues = (props: any) => {
    const fields = [
      'additionalWithholdingAmount',
      'ageover65',
      'isblind',
      'withholdingforyourself',
      'headofhousehold',
      'noofdependents',
      'widowwithdependentchild',
      'domesticpartner65yearsofage',
      'partnerisblind',
      'itemizeddeductions'
    ]
    for (let i = 0; i < fields.length; i++) {
      props.setFieldValue(fields[i], '')
    }
  }
  let kcolumnvalue = 0
  let lcolumnvalue = 0
  const handleallowances = (values: any) => {
    switch (values.filingStatus) {
      case 0:
      case 1:
        kcolumnvalue = 5650
        break
      case 2:
        kcolumnvalue = 7800
        break
      case 3:
      case 4:
        kcolumnvalue = 10275
        break
      default:
        kcolumnvalue = 0
        break
    }

    const partAtotal =
      Number(values.ageover65) +
      Number(values.headofhousehold) +
      Number(values.ageover65) +
      Number(values.isblind) +
      Number(values.noofdependents) +
      Number(values.widowwithdependentchild) +
      Number(values.domesticpartner65yearsofage) +
      Number(values.partnerisblind)
    lcolumnvalue = Math.abs(
      Number(kcolumnvalue) - Number(values.itemizeddeductions)
    )
    const partBtotal = Math.round(lcolumnvalue / 1775)
    const totalnumberofwithholdingallowances = partAtotal + partBtotal
    return {
      PartA: partAtotal,
      PartB: partBtotal,
      total: totalnumberofwithholdingallowances
    }
  }

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'DC Withholding Taxation '}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {
            const { PartA, PartB, total } = handleallowances(values)
            // if (mode === 'upload') {
            const data = {
              completeOnline: mode == 'online' ? true : false,
              essUserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey,
              filingStatus: Number(values?.filingStatus) + 1,
              forYourself: values?.withholdingforyourself
                ? values?.withholdingforyourself
                : null,
              filingHeadofHousehold: values?.headofhousehold
                ? values?.headofhousehold
                : null,
              age65orover: values?.ageover65 ? values?.ageover65 : null,
              isBlind: values?.isblind ? values?.isblind : null,
              numberOfDependents: values?.noofdependents
                ? values?.noofdependents
                : null,
              spouseDependentChild: values?.widowwithdependentchild
                ? values?.widowwithdependentchild
                : null,
              spousePartnerAge65orOver: values?.domesticpartner65yearsofage
                ? values?.domesticpartner65yearsofage
                : null,
              spousePartnerIsBlind: values?.partnerisblind
                ? values?.partnerisblind
                : null,
              itemizedDeductions: values?.itemizeddeductions
                ? values?.itemizeddeductions
                : null,
              filingAmount: kcolumnvalue,
              subFilingAmountandDeductions: lcolumnvalue,
              totalFromSecAlineI: PartA,
              totalFromSecBlineM: PartB,
              totalWithholdingAllowancesLineN: total,
              additionalAmount: values?.additionalWithholdingAmount
                ? values?.additionalWithholdingAmount
                : null,
              claimingExcemptions:
                Number(values?.exemptfromwithholding) == 2 ? 'Exempt' : '',
              stateOfDomicile:
                Number(values?.stateOfDomicile) == 1 ? true : false,
              stateOfDomicileName: values?.stateOfDomicileName
                ? values?.stateOfDomicileName
                : null,
              fulltimeStudent:
                Number(values?.fulltimeStudent) == 1 ? true : false
            }

            const response = await postdconline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('DCinformationonline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  kcolumnvalue,
                  lcolumnvalue,
                  PartA,
                  PartB,
                  total
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View
                    style={{
                      justifyContent: 'center',
                      width: '50%',
                      overflow: 'hidden'
                    }}
                  >
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.filingStatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('filingStatus', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.filingStatus &&
                      props.errors.filingStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingStatus as string}
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Do you want to exempt from withholding *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Do you want to exempt from withholding"
                      options={options2}
                      selectedOption={mapSelectValue(
                        options2,
                        props.values.exemptfromwithholding
                      )}
                      onSelect={(option: any) => {
                        if (option == 2) {
                          handleresetvalues(props)
                        }
                        props.setFieldValue('exemptfromwithholding', option)
                      }}
                      textColor="primary"
                    />
                    {props.touched.exemptfromwithholding &&
                      props.errors.exemptfromwithholding && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.exemptfromwithholding}
                        </Text>
                      )}
                  </View>
                </View>
                {
                  Number(props.values.exemptfromwithholding) == 1 &&
                    props.values.exemptfromwithholding != null ? (
                    <>
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {
                              'Additional amount, if any, you want withheld from each paycheck *'
                            }
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <TextInput
                            style={[
                              globalStyles.input,
                              globalStyles.inputLight
                            ]}
                            value={props.values.additionalWithholdingAmount}
                            keyboardType="numeric"
                            onChangeText={(text) => {
                              if (text === '' || /^\d+$/.test(text)) {
                                props.handleChange(
                                  'additionalWithholdingAmount'
                                )(text)
                              }
                            }}
                          />

                          {props.touched.additionalWithholdingAmount &&
                            props.errors.additionalWithholdingAmount && (
                              <Text style={globalStyles.dangerAlert}>
                                {
                                  props.errors
                                    .additionalWithholdingAmount as string
                                }
                              </Text>
                            )}
                        </View>
                      </View>

                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'Are you 65 or over *'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="Are you 65 or over "
                            options={options2}
                            selectedOption={mapSelectValue(
                              options2,
                              props.values.ageover65
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue('ageover65', option - 1)
                            }}
                            textColor="primary"
                          />
                          {props.touched.ageover65 &&
                            props.errors.ageover65 && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.ageover65}
                              </Text>
                            )}
                        </View>
                      </View>
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'Are you claiming withholding for yourself *'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="Are you claiming withholding for yourself "
                            options={options2}
                            selectedOption={mapSelectValue(
                              options2,
                              props.values.withholdingforyourself
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue(
                                'withholdingforyourself',
                                option - 1
                              )
                            }}
                            textColor="primary"
                          />
                          {props.touched.withholdingforyourself &&
                            props.errors.withholdingforyourself && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.withholdingforyourself}
                              </Text>
                            )}
                        </View>
                      </View>
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'Are you filing as a head of household *'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="Are you filing as a head of household "
                            options={options2}
                            selectedOption={mapSelectValue(
                              options2,
                              props.values.headofhousehold
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue('headofhousehold', option - 1)
                            }}
                            textColor="primary"
                          />
                          {props.touched.headofhousehold &&
                            props.errors.headofhousehold && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.headofhousehold}
                              </Text>
                            )}
                        </View>
                      </View>
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'Are you blind *'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="Are you blind "
                            options={options2}
                            selectedOption={mapSelectValue(
                              options2,
                              props.values.isblind
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue('isblind', option - 1)
                            }}
                            textColor="primary"
                          />
                          {props.touched.isblind && props.errors.isblind && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.isblind}
                            </Text>
                          )}
                        </View>
                      </View>

                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'No of dependents *'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <TextInput
                            style={[
                              globalStyles.input,
                              globalStyles.inputLight
                            ]}
                            value={props.values.noofdependents}
                            keyboardType="numeric"
                            onChangeText={(text) => {
                              if (text === '' || /^\d+$/.test(text)) {
                                props.handleChange('noofdependents')(text)
                              }
                            }}
                          />

                          {props.touched.noofdependents &&
                            props.errors.noofdependents && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.noofdependents as string}
                              </Text>
                            )}
                        </View>
                      </View>

                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {
                              'Are you filing jointly with your spouse or registered domestic partner, or filing separately on the same return, or are you a qualifying widow(er) with a dependent child *'
                            }
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="Are you filing jointly with your spouse or registered domestic partner, or filing separately on the same return, or are you a qualifying widow(er) with a dependent child "
                            options={options2}
                            selectedOption={mapSelectValue(
                              options2,
                              props.values.widowwithdependentchild
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue(
                                'widowwithdependentchild',
                                option - 1
                              )
                            }}
                            textColor="primary"
                          />
                          {props.touched.widowwithdependentchild &&
                            props.errors.widowwithdependentchild && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.widowwithdependentchild}
                              </Text>
                            )}
                        </View>
                      </View>
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {
                              'Are you married or a registered domestic partner filing jointly or separately on the same return, and is your spouse or registered domestic partner 65 years of age or older *'
                            }
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="Are you married or a registered domestic partner filing jointly or separately on the same return, and is your spouse or registered domestic partner 65 years of age or older "
                            options={options2}
                            selectedOption={mapSelectValue(
                              options2,
                              props.values.domesticpartner65yearsofage
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue(
                                'domesticpartner65yearsofage',
                                option - 1
                              )
                            }}
                            textColor="primary"
                          />
                          {props.touched.domesticpartner65yearsofage &&
                            props.errors.domesticpartner65yearsofage && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.domesticpartner65yearsofage}
                              </Text>
                            )}
                        </View>
                      </View>
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {
                              'Are you married or a registered domestic partner filing jointly or separately on the same return, and is your spouse or registered domestic partner blind *'
                            }
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="Are you married or a registered domestic partner filing jointly or separately on the same return, and is your spouse or registered domestic partner blind "
                            options={options2}
                            selectedOption={mapSelectValue(
                              options2,
                              props.values.partnerisblind
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue('partnerisblind', option - 1)
                            }}
                            textColor="primary"
                          />
                          {props.touched.partnerisblind &&
                            props.errors.partnerisblind && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.partnerisblind}
                              </Text>
                            )}
                        </View>
                      </View>

                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'Enter estimate of your itemized deductions  *'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <TextInput
                            style={[
                              globalStyles.input,
                              globalStyles.inputLight
                            ]}
                            value={props.values.itemizeddeductions}
                            keyboardType="numeric"
                            onChangeText={(text) => {
                              if (text === '' || /^\d+$/.test(text)) {
                                props.handleChange('itemizeddeductions')(text)
                              }
                            }}
                          />

                          {props.touched.itemizeddeductions &&
                            props.errors.itemizeddeductions && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.itemizeddeductions as string}
                              </Text>
                            )}
                        </View>
                      </View>
                    </>
                  ) :
                    <>
                    </>
                }

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Is your state of domicile is a state other than the District of columbia *'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Is your state of domicile is a state other than the District of columbia"
                      options={options2}
                      selectedOption={mapSelectValue(
                        options2,
                        props.values.stateOfDomicile
                      )}
                      onSelect={(option: any) => {
                        if (option == 1) {
                          props.setFieldValue('stateOfDomicileName', '')
                        }
                        props.setFieldValue('stateOfDomicile', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.stateOfDomicile &&
                      props.errors.stateOfDomicile && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.stateOfDomicile}
                        </Text>
                      )}
                  </View>
                </View>
                {
                  Number(props.values.stateOfDomicile) == 1 &&
                    props.values.stateOfDomicile != null ? (
                    <>
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View
                          style={{ justifyContent: 'center', width: '50%' }}
                        >
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {' Enter the  name of state of domicile *'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <TextInput
                            style={[
                              globalStyles.input,
                              globalStyles.inputLight
                            ]}
                            value={props.values.stateOfDomicileName}
                            onChangeText={(text) => {
                              props.handleChange('stateOfDomicileName')(text)
                            }}
                          />

                          {props.touched.stateOfDomicileName &&
                            props.errors.stateOfDomicileName && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.stateOfDomicileName as string}
                              </Text>
                            )}
                        </View>
                      </View>
                    </>
                  ) :
                    <>
                    </>
                }

                {Number(props.values.exemptfromwithholding) == 2 &&
                  props.values.exemptfromwithholding != null ? (
                  <>
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View
                        style={{ justifyContent: 'center', width: '50%' }}
                      >
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Are you a full-time student *'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <SelectKeyValue
                          title="Are you a full-time student "
                          options={options2}
                          selectedOption={mapSelectValue(
                            options2,
                            props.values.fulltimeStudent
                          )}
                          onSelect={(option: any) => {
                            props.setFieldValue('fulltimeStudent', option - 1)
                          }}
                          textColor="primary"
                        />
                        {props.touched.fulltimeStudent &&
                          props.errors.fulltimeStudent && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.fulltimeStudent}
                            </Text>
                          )}
                      </View>
                    </View>
                  </>
                ) : <></>}

                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>
    </KeyboardAwareScrollView>
  )
}
export default DCinformationForm
